import React, { forwardRef } from "react"
import styled from "styled-components"

const FiveViewSVG = forwardRef((props, ref) => {
  return (
    <SVGWrapper ref={ref} width={props.width || 200} color={props.color} version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 225">
      <title>New Project</title>
      <path id="Layer 1" className="s0" d="m0 0h400v225h-400z"/>
      <g id="Folder 1 copy 2">
        <path id="Layer 2" className="s1" d="m12 20c0-3.3 2.7-6 6-6h87.2c3.3 0 6 2.7 6 6v43.9c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy" className="s1" d="m116.8 20c0-3.3 2.7-6 6-6h87.2c3.3 0 6 2.7 6 6v43.9c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy 2" className="s1" d="m12 80.3c0-3.4 2.7-6 6-6h87.2c3.3 0 6 2.6 6 6v43.8c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy 3" className="s1" d="m116.8 80.3c0-3.4 2.7-6 6-6h87.2c3.3 0 6 2.6 6 6v43.8c0 3.3-2.7 6-6 6h-87.2c-3.3 0-6-2.7-6-6z"/>
        <path id="Shape 1" className="s1" d="m226 20c0-3.3 2.7-6 6-6h150c3.3 0 6 2.7 6 6v80c0 3.3-2.7 6-6 6h-150c-3.3 0-6-2.7-6-6z"/>
        <path id="Shape 5" className="s2" d="m328.7 57.4q1.3 1.2 1.3 2.9 0 1.7-1.3 3l-31.1 29.1q-1.4 1.3-3.2 1.3-1.8 0-3.1-1.3-1.3-1.2-1.3-2.9v-58.3q0-1.7 1.3-3 1.3-1.2 3.1-1.2 1.8 0 3.2 1.2l31.1 29.2z"/>
        <path id="Layer 3" className="s1 browser-source" d="m226 120c0-3.3 2.7-6 6-6h150c3.3 0 6 2.7 6 6v85c0 3.3-2.7 6-6 6h-150c-3.3 0-6-2.7-6-6z"/>
        <g id="Folder 4">
          <path id="Shape 4" className="s3" d="m234 127.6v-5h144.8v5z"/>
          <path id="Shape 4 copy" className="s3" d="m234 137.6v-5h144.8v5z"/>
          <path id="Shape 4 copy 2" className="s3" d="m234 147.6v-5h144.8v5z"/>
          <path id="Shape 4 copy 3" className="s3" d="m234 157.6v-5h144.8v5z"/>
          <path id="Shape 4 copy 4" className="s3" d="m234 167.6v-5h144.8v5z"/>
          <path id="Shape 4 copy 5" className="s3" d="m234 177.6v-5h144.8v5z"/>
          <path id="Shape 4 copy 6" className="s3" d="m234 187.6v-5h144.8v5z"/>
          <path id="Shape 4 copy 7" className="s3" d="m234 197.6v-5h144.8v5z"/>
        </g>
      </g>
    </SVGWrapper>
  )
})

export default FiveViewSVG

const SVGWrapper = styled.svg`
  --color: ${props => props.color || '#fff'};
  .s0 { fill: none;stroke: var(--color);stroke-width: 10 }
  .s1 { fill: none;stroke: var(--color);stroke-width: 5 }
  .s2 { fill: var(--color);stroke: var(--color);stroke-width: 5 }
  .s3 { fill: var(--color) }

  .browser-source {
    stroke: var(--green-text);
    fill: var(--green-selected);
  }
`
